export default {
  FOVEA_MODEL_URL: 'https://getfovea.com/models',
  API_HOST: 'https://apiprod.archvision.services',
  SUPPORT_URL: 'https://docs.google.com/forms/d/e/1FAIpQLSeXIlMYEQ8HXvqkiGBiZexcByy9QGEAlSEidY5EWnJZLE5OlQ/viewform',
  EDIT_MODEL_FORMAT: 'GLB',
  VIEWER_MODEL_FORMAT: 'DRACO_GLB',
  FORMAT_AVAILABLE: 'AVAILABLE',
  DEFAULT_MODEL_TITLE: 'Your model',
  // Where the model sits in the conversion pipeline. RESOLVING/READY are ours,
  // the rest mirror the job statuses the API reports.
  JOB_PHASES: {
    IDLE: 'IDLE',
    RESOLVING: 'RESOLVING',
    WAITING_FOR_FILE: 'WAITING_FOR_FILE',
    QUEUED: 'QUEUED',
    PROCESSING: 'PROCESSING',
    COMPLETED: 'COMPLETED',
    READY: 'READY',
    FAILED: 'FAILED',
    NOT_FOUND: 'NOT_FOUND',
    UNAVAILABLE: 'UNAVAILABLE',
  },
  JOB_STATUSES: {
    WAITING_FOR_FILE: 'WAITING_FOR_FILE',
    QUEUED: 'QUEUED',
    PROCESSING: 'PROCESSING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
  },
  JOB_POLLING: {
    FAST_INTERVAL: 3000,
    SLOW_INTERVAL: 10000,
    SLOW_AFTER: 3 * 60 * 1000,
    LONG_WAIT_AFTER: 5 * 60 * 1000,
    HARD_STOP_AFTER: 15 * 60 * 1000,
    MAX_FAILURES: 3,
  },
  // A job can report COMPLETED a moment before the download becomes servable.
  DOWNLOAD_RETRY: {
    MAX_ATTEMPTS: 3,
    DELAY: 2000,
  },
  // Demo playback. This one model is already fully processed, so it would
  // normally load straight into the canvas and never show a status screen.
  // Loading it replays the whole job lifecycle on a timer instead, then hands
  // over the real download URL so Open model opens the actual model.
  // Every other guid takes the untouched download -> 404 -> chain path.
  DEMO_GUID: '21-CAFF-3A5D-9BD4-30E4-23E4-4B07-FC1C-CBFB-00',
  // Keyed by phase name; how long the demo sits on each screen.
  DEMO_STAGE_DURATIONS: {
    WAITING_FOR_FILE: 3000,
    QUEUED: 3000,
    PROCESSING: 5000,
    COMPLETED: 2500,
  },
  THEME: {
    DARK: 'dark',
    LIGHT: 'light',
  },
  ORTHO: {
    LEFT: 'orthoLeft',
    RIGHT: 'orthoRight',
    TOP: 'orthoTop',
    BOTTOM: 'orthoBottom',
    FRONT: 'orthoFront',
    BACK: 'orthoBack',
  },
  CANVAS_UPDATE_TYPES: {
    MATERIAL: 'material',
    MESH: 'mesh',
    CAMERA: 'camera',
    ENVIRONMENT: 'environment',
    TEXTURE: 'texture',
    VIEWPORT: 'viewport',
    PUBLISH: 'publish',
  },
  CANVAS_UPDATE_METHODS: {
    ADD: 'add',
    UPDATE: 'update',
    REMOVE: 'remove',
  },
  RATIOS: {
    square: { name: 'square', label: '1:1', value: 1 },
    broadcast: { name: 'broadcast', label: '4:3', value: 1.33 },
    cinema: { name: 'cinema', label: '16:9', value: 1.77 },
  },
  MESSAGE_TYPES: {
    error: 'error',
    warning: 'warning',
    info: 'info',
    success: 'success',
    loading: 'loading',
    deletion: 'deletion',
  },
};